import Cookies from "universal-cookie";

export const pushToDataLayer = (data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
};

export const pushUserIdToDataLayer = () => {
    const cookies = new Cookies();
    const userId = cookies.get('acount');  // Same name used when setting
  
    if (userId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "user-id": userId
      });
    }
  };

  export const pushCKStepsToDataLayer = (gid, gdName,steps) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4event",
      "eventName": steps,
      "VFund": "好日子",
      "VFundName": gdName,
      "FundID": gid,
      "category": "申購"
    });
  };


  export const pushPurchaseDataLayer = (gid, gdName,amount,fee,orderCurrency) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4event",
      "eventName": "Purchase",
      "TradeNo":"",
      "VFund": "好日子",
      "VFundName": gdName,
      "FundID": gid,
      "Amount": amount,
      "Fee":fee,
      "OrderCurrency":orderCurrency
    });
  };


  export const pushBNDataLayer = (gid, gdName) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4event",
      "eventName": "buy_now",
      "VFund": "好日子",
      "VFundName": gdName,
      "FundID": gid,
      "position":gdName + "_投資組合輕鬆選"
    });
  };


